"use strict";
/*
  eslint-disable @typescript-eslint/explicit-module-boundary-types
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.label = exports.headingLight = exports.heading = exports.textGray = exports.textDarkGray = exports.fontSemibold = exports.fontThin = exports.textXl = exports.textRight = exports.textLeft = exports.textCenter = exports.marginVerticalSmall = exports.paddingSmall = exports.padding = exports.fullWidth = exports.card = exports.responsiveGrid = void 0;
var responsiveGrid = function () { return ({
    "--auto-grid-min-size": "20rem",
    display: "grid",
    "grid-template-columns": "repeat(auto-fill, minmax(var(--auto-grid-min-size), 1fr))",
    "grid-gap": "1rem",
}); };
exports.responsiveGrid = responsiveGrid;
var card = function () { return ({
    backgroundColor: "white",
    borderRadius: "4px",
    boxShadow: "0 1px 5px rgba(0,0,0,0.2)",
    padding: "0",
}); };
exports.card = card;
var fullWidth = function () { return ({
    width: "100%",
    "max-width": "100vw",
}); };
exports.fullWidth = fullWidth;
var padding = function () { return ({
    padding: "1rem",
}); };
exports.padding = padding;
var paddingSmall = function () { return ({
    padding: "0.25rem",
}); };
exports.paddingSmall = paddingSmall;
var marginVerticalSmall = function () { return ({
    marginTop: "0.25rem",
    marginBottom: "0.25rem",
}); };
exports.marginVerticalSmall = marginVerticalSmall;
var textCenter = function () { return ({
    textAlign: "center",
}); };
exports.textCenter = textCenter;
var textLeft = function () { return ({
    textAlign: "left",
}); };
exports.textLeft = textLeft;
var textRight = function () { return ({
    textAlign: "right",
}); };
exports.textRight = textRight;
var textXl = function () { return ({
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
}); };
exports.textXl = textXl;
var fontThin = function () { return ({
    fontWeight: "100",
}); };
exports.fontThin = fontThin;
var fontSemibold = function () { return ({
    fontWeight: "600",
}); };
exports.fontSemibold = fontSemibold;
var textDarkGray = function () { return ({
    color: "rgb(55, 65, 81,)",
}); };
exports.textDarkGray = textDarkGray;
var textGray = function () { return ({
    color: "rgb(107, 114, 128)",
}); };
exports.textGray = textGray;
var heading = function () { return (__assign(__assign(__assign(__assign(__assign({}, (0, exports.textCenter)()), (0, exports.textXl)()), (0, exports.fontSemibold)()), (0, exports.textDarkGray)()), { margin: "0" })); };
exports.heading = heading;
var headingLight = function () { return (__assign(__assign(__assign(__assign({}, (0, exports.textGray)()), (0, exports.fontThin)()), (0, exports.textXl)()), { margin: "0" })); };
exports.headingLight = headingLight;
var label = function () { return (__assign(__assign({}, (0, exports.textGray)()), (0, exports.fontSemibold)())); };
exports.label = label;
//# sourceMappingURL=baseStyles.js.map